import { ToggleComponent } from '../../../featureToggle';
import Footer from './Footer';
import FooterNuttall from '../../../customized/alan-nuttall-flexeserve-eu/components/footer/Footer';

export default ToggleComponent(Footer, {
  styledComponentsVariants: {
    'alan-nuttall-flexeserve-eu': FooterNuttall,
  },
});
